import React from 'react';
import PropTypes from "prop-types";
import {css, useTheme} from "@emotion/react";
import { em } from "@util/convertUnits";
import {buttonClick} from "@util/buttonClick";

const FileWidget = ({content}) => {

    const { file } = content;
    const theme = useTheme();
    const fontTheme = theme.header.fontFamily;

    const fileImgContainer = css(`
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        @media (min-width: ${em(theme.breakpoint.ns, 16)}) {
            flex-direction: row;
            justify-content: space-between;
        }
    `);


    const labelStyles = css(`
        font-family: ${fontTheme};
        display: flex;
        flex-wrap: wrap;
        text-align:left;
        align-items: center;
        text-decoration: underline;
        cursor: pointer;
    `);

    const downloadFile = (file) => {
        const link = document.createElement('a');
        link.href = file.file_url;
        link.target = '_blank';
        link.click();
    }

    return ( 
    <div style={{maxWidth: "100%", width: "70rem"}}>
        {file?.map((item) => (
            <div key={item.file_url} css={fileImgContainer} className={'pb-2'} tabIndex={0} role={'button'} onKeyDown={(e)=>buttonClick(e)} onClick={() => downloadFile(item)}>
                <div css={labelStyles}>
                    {item.file_label}
                </div>
                {/*<div css={svgContainer}>*/}
                {/*    <svg tabIndex={0} role='button' width="40" height="40" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">*/}
                {/*        <path fill="#95979a" d="M5.74.48V29.73h23V8.09L21.11.48ZM7,1.74H20.22V9h7.23V28.46H7Zm14.47.9,5.08,5.08H21.48Z"/>*/}
                {/*        <path fill="#da6d6d" d="M1.42,25.49H25.48V13H1.42Z"/>*/}
                {/*        <g>*/}
                {/*            <path fill="#ffffff" d="M10.55,18.34a1.89,1.89,0,0,1-.12.67,1.46,1.46,0,0,1-.34.55,2.21,2.21,0,0,1-.68.46,2.52,2.52,0,0,1-.93.15H7.67v1.66H6.35V16.74H8.51a3.72,3.72,0,0,1,.82.08,2.1,2.1,0,0,1,.59.25,1.37,1.37,0,0,1,.47.52A1.6,1.6,0,0,1,10.55,18.34Zm-1.35,0A.61.61,0,0,0,9.08,18a.66.66,0,0,0-.27-.21,1,1,0,0,0-.4-.09H7.67v1.52H8a2.81,2.81,0,0,0,.55,0A.75.75,0,0,0,9,19a.61.61,0,0,0,.18-.26A1,1,0,0,0,9.2,18.37Z"/>*/}
                {/*            <path fill="#ffffff" d="M16.29,19.29A2.55,2.55,0,0,1,16,20.56a2.39,2.39,0,0,1-1.64,1.18,5.41,5.41,0,0,1-1.05.09h-1.8V16.74h1.85a4.81,4.81,0,0,1,1.07.1,2.41,2.41,0,0,1,.76.3A2.28,2.28,0,0,1,16,18,2.67,2.67,0,0,1,16.29,19.29Zm-1.35,0a1.88,1.88,0,0,0-.19-.86,1.22,1.22,0,0,0-.58-.56,1.53,1.53,0,0,0-.41-.14,4.85,4.85,0,0,0-.63,0H12.8v3.18h.33a3.75,3.75,0,0,0,.68,0,1.69,1.69,0,0,0,.43-.15,1.27,1.27,0,0,0,.53-.55A2,2,0,0,0,14.94,19.28Z"/>*/}
                {/*            <path fill="#ffffff" d="M20.94,17.72H18.6v1h2.17v1H18.6v2.18H17.29V16.74h3.65Z"/>*/}
                {/*        </g>*/}
                {/*    </svg>*/}
                {/*</div>*/}
            </div>)
        )}
    </div>
    )};

FileWidget.propTypes = {
        content: PropTypes.object
};

export default FileWidget;